// Full Calendar Plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'

import useJwt from "@/auth/jwt/useJwt";

// Notification
import {useToast} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {computed, onMounted, ref} from '@vue/composition-api'

const STATUS_COLOR = {
  0: {
    border: "rgba(255, 0, 0, 1)",
    background: "rgba(255, 0, 0, 0.1)"
  },
  1: {
    border: "rgba(0, 255, 0, 1)",
    background: "rgba(0, 255, 0, 0.1)"
  },
  2: {
    border: "rgba(255, 255, 0, 1)",
    background: "rgba(255, 255, 0, 0.1)"
  },
  3: {
    border: "rgba(255, 255, 0, 1)",
    background: "rgba(255, 255, 0, 0.1)"
  }
}

export default function userCalendar() {
  const toast = useToast()
  const refCalendar = ref(null)

  const events = ref([])
  const isDataLoading = ref(false)

  const rangeFilter = ref([])
  const currentMonthYear = ref({
    month: null,
    year: null,
  })
  const currentType = ref('')
  let calendarApi = null
  onMounted(() => {
    calendarApi = refCalendar.value.getApi()
  })

  const calendarsColor = {
    Business: 'primary',
    Holiday: 'success',
    Personal: 'danger',
    Family: 'warning',
    ETC: 'info',
  }

  const blankEvent = {
    title: '',
    start: '',
    end: '',
    allDay: false,
    url: '',
    extendedProps: {
      calendar: '',
      guests: [],
      location: '',
      description: '',
    },
  }
  const event = ref(JSON.parse(JSON.stringify(blankEvent)))
  const clearEventData = () => {
    event.value = JSON.parse(JSON.stringify(blankEvent))
  }

  const updateEventInCalendar = (updatedEventData, propsToUpdate, extendedPropsToUpdate) => {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Event Updated',
        icon: 'CheckIcon',
        variant: 'success',
      },
    })
    const existingEvent = calendarApi.getEventById(updatedEventData.id)
    for (let index = 0; index < propsToUpdate.length; index++) {
      const propName = propsToUpdate[index]
      existingEvent.setProp(propName, updatedEventData[propName])
    }

    existingEvent.setDates(updatedEventData.start, updatedEventData.end, { allDay: updatedEventData.allDay })

    for (let index = 0; index < extendedPropsToUpdate.length; index++) {
      const propName = extendedPropsToUpdate[index]
      existingEvent.setExtendedProp(propName, updatedEventData.extendedProps[propName])
    }
  }
  const grabEventDataFromEventApi = eventApi => {
    const {
      id,
      title,
      start,
      end,
      // eslint-disable-next-line object-curly-newline
      extendedProps: { calendar, guests, location, description,eventUrl },
      allDay,
    } = eventApi

    return {
      id,
      title,
      start,
      end,
      extendedProps: {
        calendar,
        guests,
        location,
        description,
        eventUrl
      },
      allDay,
    }
  }

  const addEvent = eventData => {
    events.value.push(eventData)
  }
  const updateEvent = eventData => {
  }
  const removeEvent = () => {
    const eventId = event.value.id

    events.value = events.value.filter(item => item.id && item.id != eventId)
  }
  const refetchEvents = () => {
    calendarApi.refetchEvents()
  }
  const fetchEvents = (info, successCallback) => {
  }
  const calendarOptions = ref({
    plugins: [dayGridPlugin, timeGridPlugin],
    initialView: 'dayGridMonth',
    headerToolbar: {
      start: 'sidebarToggle, prev,next, title',
      end: 'dayGridMonth,timeGridWeek',
    },
    events: events,
    editable: false,
    eventResizableFromStart: true,
    dragScroll: false,
    dayMaxEvents: 2,
    navLinks: false,
    allDaySlot: false,
    eventMaxStack: 1,
    eventClassNames(arg) {
      const colorName = calendarsColor[arg?.calendarEvent?._def.extendedProps?.calendar]

      return [
        `bg-light-${colorName}`,
      ]
    },
    eventClick({ event: clickedEvent }) {
      event.value = grabEventDataFromEventApi(clickedEvent)
      isEventHandlerSidebarActive.value = true
    },

    customButtons: {
      sidebarToggle: {
        text: 'sidebar',
        click() {
          // eslint-disable-next-line no-use-before-define
          isCalendarOverlaySidebarActive.value = !isCalendarOverlaySidebarActive.value
        },
      },
    },

    dateClick(info) {
      event.value = JSON.parse(JSON.stringify(Object.assign(event.value, { start: info.date })))
      isEventHandlerSidebarActive.value = true
    },
    eventDrop({ event: droppedEvent }) {
      updateEvent(grabEventDataFromEventApi(droppedEvent))
    },
    eventResize({ event: resizedEvent }) {
      updateEvent(grabEventDataFromEventApi(resizedEvent))
    },
    eventChange(changeInfo) {
    },
    direction: computed(() => ('ltr')),
    rerenderDelay: 350,
    datesSet(event) {
      let midDate = new Date((event.start.getTime() + event.end.getTime()) / 2)
      let month = midDate.getMonth() + 1
      let year = midDate.getFullYear()
      if(currentType.value !== event.view.type || currentMonthYear.value.month != month || currentMonthYear.value.year != year) {
        currentType.value = event.view.type
        events.value = [];
        currentMonthYear.value.month = month
        currentMonthYear.value.year = year
        getMonthData(month, year)
      }
    },
    moreLinkClick: function(agr) {
      let target = agr.jsEvent.target
      let parent = null
      for(let i = 0; i < 6; i++) {
        if(target.parentElement.className && (
          target.parentElement.className.includes('fc-day-past') ||
          target.parentElement.className.includes('fc-day-today') ||
          target.parentElement.className.includes('fc-day-future')
        )) {
          parent = target.parentElement
          break
        }
        target = target.parentElement
      }
      setTimeout(() => {
        const popupEl = document.getElementsByClassName('fc-more-popover')[0]
        if(popupEl && parent) {
          popupEl.setAttribute('style', `top: ${parent.offsetTop + 26.0694}px; left: ${parent.offsetLeft}px`)
        }
      }, 350);
    },
  })

  const getMonthData = (month, year) => {
    isDataLoading.value = true
    useJwt.get(`calendar/${month}/${year}`).then(data => {
      if(data.data.result){

        if(currentType.value === 'dayGridMonth') {
          let daysKey = Object.keys(data.data.result)
          daysKey.forEach(el => {
            data.data.result[el].forEach(o => {
              let newEvent = {
                title: o.title,
                start: el,
                end: el,
                allDay: true,
                backgroundColor: STATUS_COLOR[o.status].background,
                borderColor: STATUS_COLOR[o.status].border,
                textColor: "red"
              }
              addEvent(newEvent)
            })
          })
        }
        else if(currentType.value === 'timeGridWeek') {
          let daysKey = Object.keys(data.data.extra.week)
          daysKey.forEach(el => {
            data.data.extra.week[el].forEach(o => {
              let newEvent = {
                title: o.notifyTitle,
                start: `${el}T${o.sendInDay}`,
                end: `${el}T${o.sendInDay}`,
                allDay: false,
                backgroundColor: STATUS_COLOR[o.status].background,
                borderColor: STATUS_COLOR[o.status].border,
                textColor: "red"
              }
              addEvent(newEvent)
            })
          })
        }
      }
      isDataLoading.value = false
    })
  }

  const isEventHandlerSidebarActive = ref(false)

  const isCalendarOverlaySidebarActive = ref(false)

  return {
    refCalendar,
    isCalendarOverlaySidebarActive,
    calendarOptions,
    event,
    clearEventData,
    addEvent,
    updateEvent,
    removeEvent,
    refetchEvents,
    fetchEvents,
    isDataLoading,

    // ----- UI ----- //
    isEventHandlerSidebarActive,
  }
}
